import { render } from "./HistoryItem.vue?vue&type=template&id=fdb42e20&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"

import "./HistoryItem.vue?vue&type=style&index=0&id=fdb42e20&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb42e20"]])

export default __exports__